export default "__VITE_ASSET__Q_g_d07d__"